import { render, staticRenderFns } from "./ViewPlanCompany.vue?vue&type=template&id=2b072bc3"
import script from "./ViewPlanCompany.vue?vue&type=script&lang=js"
export * from "./ViewPlanCompany.vue?vue&type=script&lang=js"
import style0 from "./ViewPlanCompany.vue?vue&type=style&index=0&id=2b072bc3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports